"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputRelay__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "contract IInputBox",
                name: "_inputBox",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "getInputBox",
        outputs: [
            {
                internalType: "contract IInputBox",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "0x60a060405234801561001057600080fd5b5060405161012738038061012783398101604081905261002f91610040565b6001600160a01b0316608052610070565b60006020828403121561005257600080fd5b81516001600160a01b038116811461006957600080fd5b9392505050565b608051609f6100886000396000602e0152609f6000f3fe6080604052348015600f57600080fd5b506004361060275760003560e01c8062aace9a14602c575b600080fd5b7f00000000000000000000000000000000000000000000000000000000000000006040516001600160a01b03909116815260200160405180910390f3fea26469706673582212204f57d0a66ead46eb115fe03ed1ea4238a28b5c26ea9292af08fc23144b50d13264736f6c63430008130033";
const isSuperArgs = (xs) => xs.length > 1;
class InputRelay__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(_inputBox, overrides) {
        return super.deploy(_inputBox, overrides || {});
    }
    getDeployTransaction(_inputBox, overrides) {
        return super.getDeployTransaction(_inputBox, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.InputRelay__factory = InputRelay__factory;
InputRelay__factory.bytecode = _bytecode;
InputRelay__factory.abi = _abi;
